export enum Gender {
	MALE = "Male",
	FEMALE = "Female",
}

export enum GeneralRoleEnum {
	SUPER_ADMIN = "super_admin",
}

export enum PermissionEnum {
	CompaniesRead = "companies:read",
	CompaniesCreate = "companies:create",
	CompaniesUpdate = "companies:update",
	CompaniesDelete = "companies:delete",

	DhcRead = "dhc:read",
	DhcCreate = "dhc:create",
	DhcUpdate = "dhc:update",
	DhcDelete = "dhc:delete",

	DhcNotesRead = "dhc_notes:read",
	DhcNotesCreate = "dhc_notes:create",
	DhcNotesUpdate = "dhc_notes:update",
	DhcNotesDelete = "dhc_notes:delete",

	EndusersRead = "endusers:read",
	EndusersCreate = "endusers:create",
	EndusersUpdate = "endusers:update",
	EndusersDelete = "endusers:delete",

	EndUserNotesRead = "enduser_notes:read",
	EndUserNotesCreate = "enduser_notes:create",
	EndUserNotesUpdate = "enduser_notes:update",
	EndUserNotesDelete = "enduser_notes:delete",

	StatisticsRead = "statistics:read",

	DashboardRead = "dashboard:read",

	RbacRead = "rbac:read",
	RbacManage = "rbac:manage",
}

export interface UserDetails {
	id: number;
	firstName?: string;
	lastName?: string;
	gender?: string;
	profilePicture?: string;
	languageId: number;
	email?: string;
	phoneNumber?: string;
	countryCode?: string;
}

export interface UserResponse {
	data: UserProfileDetails[];
}

export interface UpdateUserResponse {
	Response: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PresignedFormDataProfilePhoto: any;
}

export interface UserProfileDetails {
	UserId: string;
	FirstName: string;
	LastName: string;
	Email: string;
	FacebookId: string;
	LanguageId: string;
	PreferredMeasuringSystem: string;
	Height: string;
	Weight: string;
	Gender: string;
	DOB: string;
	ProfilePhotoUrl: string;
	CoverPhotoUrl: string;
	GoalId: string;
	GoalName: string;
	HeightUnit: string;
	WeightUnit: string;
	UserName: string;
	TwilioSId: string;
	BankAccountNo: string;
	CoachNameText: string;
	IsCoachExist: string;
	FullAddress: string;
	CountryId: string;
	Zip: string;
	CurrencyId: string;
	CurrencyName: string;
	IsCurrencyLocked: string;
	OrganizationId: number;
	PDFLogo: string;
	IsSalesGetStarted: number;
	OrganizationNumber: string;
	OrganizationName: string;
	ChatToken: string;
	AddressLine1: string;
	AddressLine2: string;
	StateId: string;
	CityId: string;
	AppRedirectSchemaUrl: string;
	PersonalNumber: string;
	HERId: string;
	IsoCode: string;
	HasAccess: boolean;
	IsBankIdEnabled: boolean;
	IsPreRegistered: boolean;
	PhoneNumber: string;
	CountryCode: string;
	IsVerified: boolean;
}

export type UpdateUserProfileRequest = {
	UserId: string;
	FirstName?: string;
	LastName?: string;
	Height?: string;
	HeightUnit?: string;
	Weight?: string;
	WeightUnit?: string;
	Gender?: Gender;
	DOB?: string;
	UserName?: string;
	Email?: string;
	BankAccountNo?: string;
	IsVerified?: "1" | "0";
	IsPreRegistered?: "1" | "0";
	LanguageId?: string;
	FullAddress?: string;
	Zip?: string;
	CurrencyId?: string;
	Unit?: string;
	AddressLine1?: string;
	AddressLine2?: string;
	StateId?: string;
	CityId?: string;
	PersonalNumber?: string;
	HERId?: string;
	ProfilePhotoContentType?: "ProfilePhoto" | "CoverPhoto";
	ProfilePhotoFileName?: string;
	file?: File;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface UpdateProfileResponse {
	Response: number;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PresignedFormDataProfilePhoto: any;
}

export interface UpdateProfilePayload {
	UserId: string;
	FirstName: string;
	Gender: string;
	file?: File;
	PhoneNumber?: string;
	ProfilePhotoContentType?: string;
	ProfilePhotoFileName?: string;
	LanguageId: string;
	LastName: string;
	CountryCode: string;
}

export interface AccessTokenResponse {
	result: {
		accessToken: string;
		refreshToken: string;
	};
}

export interface UserVerifyEmail {
	result: UserResponseData;
}

export interface UserResponseData {
	accessToken: string;
	refreshToken: string;
	user: UserDetails;
}

interface LoginFormProps {
	setCompleteRegistrationStep: (value: number) => void;
	token: string;
	email: string;
	handleMutate: (email: string) => void;
}
interface Result {
	token: string;
}

interface VerificationEmailPayload {
	email: string;
	languageId: number;
}

interface VerificationEmailResponse {
	result: Result;
}

interface VerifyEmailPayload {
	code: string;
	token: string;
	email: string;
	languageId: number;
}

interface InitSignupPayload {
	display: string;
	clientType: string;
	domain: string;
}

interface InitSignupResponse {
	redirectUrl: string;
}

interface LoginWithBankIdProps {
	email: string;
	code: string;
}

interface LoginEmailProps {
	setCompleteRegistrationStep: (value: number) => void;
	handleMutate: (email: string) => void;
	setValue: (value: string) => void;
}

interface LoginManagementPayload {
	email: string;
	password: string;
	domain: string;
}

interface ResultLoginManagement {
	result: LoginManagementResponse;
}

interface LoginManagementResponse {
	accessToken: string;
	refreshToken: string;
}

export interface UserRbacResponse {
	id: number;
	userId: number;
	roleId: number;
	roleName: string;
	roleSlug: string;
	permissions: string[];
	createdAt: string;
	updatedAt: string;
}

export type {
	LoginEmailProps,
	LoginFormProps,
	LoginManagementPayload,
	VerificationEmailResponse,
	LoginManagementResponse,
	ResultLoginManagement,
	VerificationEmailPayload,
	VerifyEmailPayload,
	InitSignupPayload,
	InitSignupResponse,
	LoginWithBankIdProps,
};
